module.exports = __webpack_public_path__ + "static/media/letterDinamic.7d44c245.gif";